import { SxProps } from "@mui/system";
import { ThemeV2 } from "../../util/types";
import { optionalGridLineStyle } from "../grid/gridInstrumentStyle";
import { actionBtnWrapper } from "../rating/styles";

export const questionWrapper = (theme: ThemeV2): SxProps => ({
  width: "100%",
  maxWidth: "90%",
  padding: `${theme.tokens.spacing["5"]}px ${theme.tokens.spacing["4"]}px`,
  border: `1px solid ${theme.tokens.color.action.primary}`,
  borderRadius: `${theme.tokens.shape.radius.lg}px`,
  margin: "0 auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  gap: theme.show_grid_lines ? undefined : `${theme.tokens.spacing["3"]}px`,
  backgroundColor: theme.tokens.color.surface.card,

  "& > div": { flex: "1 1 auto" },
});

export const actionBtnThisOrThat: SxProps = {
  ...actionBtnWrapper,
  "@media (max-height: 300px)": {
    position: "relative",
  },
};

export const parentContainer: SxProps = {
  height: "100%",
};

export const gridThisOrThatRowStyle = (
  theme: ThemeV2,
  compact: boolean,
  isLast: boolean,
): SxProps => ({
  ...(compact ? {} : optionalGridLineStyle(theme)),
  ...(!compact && theme.show_grid_lines && !isLast ? { borderBottom: 0 } : {}),
});

export const buttonStyle = (
  theme: ThemeV2,
  sourceBaseSelect: () => { selected: boolean | undefined; disabled: boolean },
  isLast?: boolean,
  isFirst?: boolean,
  source?: string,
  isImageExist?: boolean,
): SxProps => ({
  ...(source !== "this-or-that" &&
    source !== "this-or-that-button" && {
      maxWidth: "32%",
      minWidth: "20%",
    }),
  fontSize: {
    sm: theme.tokens.typography.size.md,
    xs: theme.tokens.typography.size.xs,
  },
  width: "100%",
  padding: `${theme.tokens.spacing["1"]}px ${theme.tokens.spacing["5"]}px`,
  ...(!isImageExist && {
    border: `1px solid ${theme.tokens.color.action.primary}`,
    borderRadius: theme.tokens.shape.radius.none,
  }),

  color: theme.tokens.color.action.primary,
  fontWeight: theme.tokens.typography.weight.regular,
  textTransform: "none",
  ...(!isLast && {
    borderBottom: 0,
  }),
  ...(sourceBaseSelect().disabled && {
    borderColor: theme.tokens.color.border.default,
    backgroundColor: theme.tokens.color.text.secondary,
    color: theme.tokens.color.text.inverse,
    ...(!isFirst && {
      borderTopColor: theme.tokens.color.surface.card,
    }),
    "&:hover": {
      backgroundColor: theme.tokens.color.border.default,
    },
  }),
  ...(sourceBaseSelect().selected && {
    borderColor: theme.tokens.color.action.primary,
    backgroundColor: theme.tokens.color.action.primary,
    color: theme.tokens.color.action.primaryText,
    /* c8 ignore next 3 */
    ...(!isFirst && {
      borderTopColor: theme.tokens.color.surface.card,
    }),
    "&:hover": {
      backgroundColor: theme.tokens.color.action.primary,
    },
  }),
});

export const textStyle = (theme: ThemeV2): SxProps => ({
  marginX: `${theme.tokens.spacing["2"]}px`,
  fontSize: theme.tokens.typography.size.lg,
  lineHeight: theme.tokens.typography.lineHeight.relaxed,
  textAlign: "center",
  fontWeight: theme.tokens.typography.weight.medium,
  marginBottom: 0,
});
